/* global Swiper */
/**
 * Swiper.js（Vanilla JS） ver1.0.0
 * ES6
 *
 * □機能
 *
 * □使い方
 *
 */
export default (APP) => {
  /*
   * トップ：メインカルーセル
   */
  const configCarousel = {
    preloadImages: false,
    lazy: {
      // loadPrevNext: true,
      loadOnTransitionStart: true
    },
    speed: 2500,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false
    },
    keyboardControl: true,
    loop: true,
    effect: 'fade',
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 0
  }
  const carousel = document.querySelectorAll('[data-swiper="home-carousel"]')
  for (let i = 0, l = carousel.length; i < l; i++) {
    const sCarousel = new Swiper(carousel[i], configCarousel) // eslint-disable-line
  }

  /*
   * 商品スライダー
   */
  const configCard = {
    // speed: 2500,
    // autoplay: {
    //   delay: 4000,
    //   disableOnInteraction: false,
    // },
    keyboardControl: true,
    // simulateTouch: false,
    // loop: true,
    effect: 'slide',
    slidesPerView: 4,
    slidesPerGroup: 4,
    spaceBetween: 30,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
      // type: 'fraction',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    breakpoints: {
      1023: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 15
      },
      767: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 15
      },
      567: {
        slidesPerView: 1,
        slidesPerGroup: 1
        // simulateTouch: true
      }
    }
  }
  const product = document.querySelectorAll('[data-swiper="card"]')
  if (product) {
    for (let i = 0, l = product.length; i < l; i++) {
      const sProduct = new Swiper(product[i], configCard) // eslint-disable-line
    }
  }

  /*
   * 商品スライダー
   */
  const configBanner = {
    speed: 2000,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false
    },
    keyboardControl: true,
    // simulateTouch: false,
    // loop: true,
    effect: 'slide',
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 30,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
      // type: 'fraction',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    breakpoints: {
      1023: {
        slidesPerView: 1.2,
        centeredSlides: true,
        spaceBetween: 15
      },
      567: {
        slidesPerView: 1.2,
        centeredSlides: true,
        spaceBetween: 10
      }
    }
  }
  const banner = document.querySelectorAll('[data-swiper="banner"]')
  if (banner) {
    for (let i = 0, l = banner.length; i < l; i++) {
      const sBanner = new Swiper(banner[i], configBanner) // eslint-disable-line
    }
  }
}
